import styled from 'styled-components';

export const TableFiltersLayout = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'visible',
})<{ visible: boolean }>`
    position: sticky;
    top: ${({ visible }) => (visible ? 'var(--custom-table-sticky-top-no-filters)' : '-100%')};
    z-index: 109;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    justify-content: space-between;
    padding: 16px;
    overflow-x: auto;
    background-color: #fff;
    border-top: 1px solid #c2bab5;

    owc-select-dropdown {
        display: flex;
    }
`;

export const TableFiltersOptionsLayout = styled.div`
    display: flex;
    flex-wrap: nowrap;
    gap: 1rem;
    padding: 0.25rem;

    &.show-all {
        flex-wrap: wrap;
        overflow: visible;
    }
`;

export const TableFiltersActionsLayout = styled.div`
    display: flex;
    flex-direction: row;
`;
